"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const client_1 = require("react-dom/client");
const IdHeader_1 = __importDefault(require("../../components/IdHeader"));
const ArrowButton_1 = __importDefault(require("../../components/ArrowButton"));
const Launchpad = () => {
    const [companies, setCompanies] = (0, react_1.useState)([]);
    const [roles, setRoles] = (0, react_1.useState)([]);
    const [actions, setActions] = (0, react_1.useState)([]);
    (0, react_1.useEffect)(() => {
        var _a, _b, _c;
        if (document.getElementById("react-data")) {
            try {
                let data = document
                    .getElementById("react-data")
                    .getAttribute("encoded");
                let parsed_data = JSON.parse(data);
                setCompanies((_a = parsed_data === null || parsed_data === void 0 ? void 0 : parsed_data.companies) !== null && _a !== void 0 ? _a : []);
                setRoles((_b = parsed_data === null || parsed_data === void 0 ? void 0 : parsed_data.roles) !== null && _b !== void 0 ? _b : []);
                setActions((_c = parsed_data === null || parsed_data === void 0 ? void 0 : parsed_data.actions) !== null && _c !== void 0 ? _c : []);
            }
            catch (error) { }
        }
    }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(IdHeader_1.default, { handlerFunction: function () {
                throw new Error("Function not implemented.");
            } }),
        react_1.default.createElement("main", { className: "launchpad" },
            react_1.default.createElement("section", { className: "launchpad__content" },
                react_1.default.createElement("div", { className: "launchpad__container" },
                    react_1.default.createElement("h1", { className: "launchpad__title" }, "What to do today?"),
                    react_1.default.createElement("div", { className: "launchpad__table" }, companies.length && (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("table", { className: "launchpad__table" }, companies.map((company) => (react_1.default.createElement("tr", null,
                            react_1.default.createElement("td", null, company.name),
                            react_1.default.createElement("td", { className: "role" }, roles[company.role_id]),
                            react_1.default.createElement("td", { className: "action" },
                                react_1.default.createElement(ArrowButton_1.default, { direction: "right", handlerFunction: function () {
                                        window.location.href =
                                            actions[company.role_id.toString()] +
                                                "/?company=" +
                                                company.id;
                                    }, label: "" }))))))))),
                    react_1.default.createElement("div", { className: "profile__tertiary-buttons" },
                        react_1.default.createElement(ArrowButton_1.default, { direction: "left", label: "Settings", handlerFunction: function () {
                                window.location.href = "/profile";
                            } })))))));
};
exports.default = Launchpad;
if (document.getElementById("user-launchpad")) {
    (0, client_1.createRoot)(document.getElementById("user-launchpad")).render(react_1.default.createElement(Launchpad, null));
}
